"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SAPStoreListingConnectionSection;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _nuiLogger = _interopRequireDefault(require("@concur/nui-logger"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _Button = _interopRequireDefault(require("@concur/nui-widgets/lib/Buttons/Button"));
var _styles = require("../styles");
var _analytics = require("../../../constants/analytics");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// this component is for sapstore type listings.

function SAPStoreListingConnectionSection(_ref) {
  var onButtonClick = _ref.onButtonClick,
    onSecondaryLinkClick = _ref.onSecondaryLinkClick,
    listingId = _ref.listingId,
    showLoginButton = _ref.showLoginButton;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    style: _styles.BUTTON_STYLE,
    innerProps: {
      className: 'max-button-width'
    },
    onClick: function onClick() {
      _nuiLogger.default.info({
        description: "Visit SAP Store button clicked on listing ".concat(listingId),
        'cte.subcategory': 'visit-sap-store-button-click'
      });
      onButtonClick(_analytics.elementList.button);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontStyle: 'italic'
    }
  }, showLoginButton ? /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "LoginToConnect"
  }) : /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "ListingButtonLabelSAPStore"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'left',
      paddingTop: '16px'
    }
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "ListingDescriptionSAPStore"
  }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    onClick: onSecondaryLinkClick
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "ListingDescriptionLinkSAPStore"
  })))));
}
SAPStoreListingConnectionSection.propTypes = {
  onButtonClick: _propTypes.default.func.isRequired,
  // Callback defined in parent
  onSecondaryLinkClick: _propTypes.default.func,
  // Callback defined in parent
  listingId: _propTypes.default.string.isRequired,
  // Callback defined in parent
  showLoginButton: _propTypes.default.bool
};